import { render } from "./AdminRiderList.vue?vue&type=template&id=3ae79c19&scoped=true&ts=true&lang=true"
import script from "./AdminRiderList.vue?vue&type=script&lang=ts"
export * from "./AdminRiderList.vue?vue&type=script&lang=ts"

import "./AdminRiderList.vue?vue&type=style&index=0&id=3ae79c19&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae79c19"]])

export default __exports__